import { render, staticRenderFns } from "./CardAddModal.vue?vue&type=template&id=5d15313c&scoped=true"
import script from "./CardAddModal.vue?vue&type=script&lang=js"
export * from "./CardAddModal.vue?vue&type=script&lang=js"
import style0 from "./CardAddModal.vue?vue&type=style&index=0&id=5d15313c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15313c",
  null
  
)

export default component.exports